import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { Device } from '@capacitor/device';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AppLauncher } from '@capacitor/app-launcher';
import { Dialog } from '@capacitor/dialog';
import { NativeBiometric } from "capacitor-native-biometric";
import { NativeSettings } from 'capacitor-native-settings';
import { Storage } from '@capacitor/storage';
import { Http } from '@capacitor-community/http';
import { Toast } from '@capacitor/toast';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { NavigationBar, NavigationBarPluginEvents } from '@hugotomazi/capacitor-navigation-bar';
import WonderPush from 'wonderpush-cordova-sdk';

const setStatusBarStyleDark = async () => {
  await StatusBar.setStyle({ style: Style.Dark });
};

/*
Device
Geolocation
Push Notifications
Splash Screen
Status Bar
Capacitor Native Biometric

const isAvailable = Capacitor.isPluginAvailable('Device');

Mobile Features
 - Geolocation
 - Biometric Auth
 - Splash Screen
 - Push Notifications
*/

export default function ({ app }, inject) {
  inject('Capacitor', Capacitor);
  inject('CapacitorBrowser', Browser);
  inject('CapacitorApp', App);
  inject('CapacitorGeolocation', Geolocation);
  inject('CapacitorStatusBar', StatusBar);
  inject('CapacitorStatusBarStyle', Style);
  inject('CapacitorDevice', Device);
  inject('CapacitorSplashScreen', SplashScreen);
  inject('CapacitorAppLauncher', AppLauncher);
  inject('CapacitorDialog', Dialog);
  inject('CapacitorNativeSettings', NativeSettings);
  inject('CapacitorNativeBiometric', NativeBiometric);
  inject('CapacitorStorage', Storage);
  inject('CapacitorToast', Toast);
  inject('CapacitorHttp', Http);
  inject('CapacitorNavigationBar', NavigationBar);
  inject('CapacitorPush', WonderPush);
} 